module.exports = __webpack_public_path__ + "img/City.88eeb31a.png";